import { addEventMergeIdIfVariationChangedAndExists } from '../../_common/client/tracking';
import { BaseComponent } from '../../base-component';

export class RecoComplementaryComponent extends BaseComponent {
    public rootSelector = '.js_pdp_reco-complementary';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        const variationId = this.getRootElement().dataset.variationId;
        if (!variationId) {
            return;
        }

        // esi will get resolved in head section
        window.o_reco?.api.loadRecommendationsForDetailView(
            addEventMergeIdIfVariationChangedAndExists({
                variationId,
                bottomTarget: this.rootSelector,
            })
        );
    }
}
